import app from './app/app';
import CartComponent from './components/cart';
import CursorComponent from './components/cursor';
import HeroComponent from './components/hero';
import HomeLoader from './components/homeloader'
import IngredientsComponent from './components/ingredients';
import IslandComponent from './components/island';
import MobileMenuComponent from './components/mobilemenu';
import ProductComponent from './components/product';
import RecipesComponent from './components/recipes';
import RelatedComponent from './components/related';
import StoreLocatorComponent from './components/storelocator';
import TopComponent from './components/top';
import detectable from './helpers/detectable';
import words from './helpers/words';
import vh from './helpers/vh';
import mediaQueries from './helpers/media';

if (sessionStorage.getItem('homeloader') === null) {
  if (document.querySelector('.page').classList.contains('page-home')) {
    sessionStorage.setItem('homeloader', '1')
  }
  else {
    sessionStorage.setItem('homeloader', '0')
  }
}

app
  .addComponent('cart', CartComponent)
  .addComponent('cursor', CursorComponent)
  .addComponent('hero', HeroComponent)
  .addComponent('homeloader', HomeLoader)
  .addComponent('ingredients', IngredientsComponent)
  .addComponent('island', IslandComponent)
  .addComponent('mobilemenu', MobileMenuComponent)
  .addComponent('product', ProductComponent)
  .addComponent('recipes', RecipesComponent)
  .addComponent('related', RelatedComponent)
  .addComponent('storelocator', StoreLocatorComponent)
  .addComponent('top', TopComponent)
  .init();

detectable.init();
words.init();
vh.init();

mediaQueries.add('until-large', '(max-width: 1023px)');
mediaQueries.add('landscape', '(orientation: landscape)');
mediaQueries.add('portrait', '(orientation: portrait)');
